module.exports = __webpack_public_path__ + "34bc775d/img/dollar-icon.35c9d638.svg";